export const envLabelSx = {
  color: '#5236AB',
  marginLeft: 8,
  fontWeight: 600,
  fontSize: '16px',
};
export const headerContainerSx = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '75px',
  px: '32px',
  py: '13px',
  backgroundColor: '#FFFFFF',
  zIndex: 1000,
  boxSizing: 'border-box',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
};

export const innerHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  height: '100%',
  ml: '20px',
};

export const rightClusterSx = {
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
  gap: '15px',
};

export const logoutButtonSx = {
  color: '#000',
  fontWeight: 500,
  fontSize: '0.875rem',
  mr: '45px', 
  textTransform: 'none',
  backgroundColor: 'transparent',
  padding: 0,
  minWidth: 'auto',
  height: '36px',
  '&:hover': {
    color: '#5236AB',
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
};

export const logoNameContainerSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '15px',
};

export const logoSx = {
  width: '75.7px',
  height: '35.2px',
  objectFit: 'contain',
};

export const separatorSx = {
  width: '1px',
  height: '36px', 
  backgroundColor: '#C0C0C0',
};

export const nameTextSx = {
  fontFamily: 'Source Sans Pro, sans-serif',
  fontWeight: 400,
  fontSize: '20px',
  lineHeight: 1,
};

export const userBlockSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const userNameSx = {
  fontWeight: 600,
  fontSize: '1rem',
};

